
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import TrustBanner from './components/TrustBanner';
import ServicesGrid from './components/ServicesGrid';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import WhyChooseUs from './components/WhyChooseUs';
import CTABanner from './components/CTABanner';
import FAQSection from './components/FAQSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <TrustBanner />
        <ServicesGrid />
        <ServiceAreas />
        <Testimonials />
        <WhyChooseUs />
        <CTABanner />
        <FAQSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
